import React, { FunctionComponent } from "react";
import "./alert-icon.scss";

const AlertIcon: FunctionComponent = () => (
  <i className="ri-alert-line AlertIcon" />
);

export default AlertIcon;
